/*
 * @Description:
 * @Author: Teemo D
 * @Date: 2021-03-22 16:07:36
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 13:57:17
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/TopConfigs/index.tsx
 */
import React from 'react';
import css from './css.less';

import BackgroundStyle from './BackgroundStyle';
import Policy from './Policy';
import Btn from './CloneButton';
import { EPreviewSize, WebSiteSubType } from '@/src/types/common/SalesChannel';
import Management from './ProfileContentManagement';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';

const TopConfigs = (props: any) => {
  const { isPrimary, currentSize, currentStyle } = props;
  const type = useSalesChannelType();

  const isNotNative =
    type === ChannelType.MiniProgram ||
    currentStyle === WebSiteSubType.ResponsivePage;

  const responsiveTabOrMobile =
    currentStyle === WebSiteSubType.ResponsivePage &&
    (currentSize === EPreviewSize.TABLET ||
      currentSize === EPreviewSize.MOBILE);

  return (
    <div className={css.container}>
      {!isPrimary && currentStyle === WebSiteSubType.NativeMobile && <Btn />}
      <BackgroundStyle
        isPrimary={isPrimary}
        currentStyle={currentStyle}
        currentSize={currentSize}
      />
      {!responsiveTabOrMobile && <Policy {...props} />}
      {isNotNative && <Management />}
    </div>
  );
};
export default TopConfigs;
